export default __webpack_public_path__ + "static/media/ic_support.424ac5f6.svg";